export default "__VITE_ASSET__f45bf2ca__"